"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var flatten_1 = __importDefault(require("lodash/flatten"));
var Model_1 = __importDefault(require("../Model"));
var CorrectionModel = /** @class */ (function (_super) {
    __extends(CorrectionModel, _super);
    function CorrectionModel(correction, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = correction.id;
        _this.score = correction.score;
        _this.comment = correction.comment;
        _this.finalizedAt = new Date(correction.finalizedAt);
        _this.essayReplyId = correction.essayReplyByEssayReplyId || correction.essayReplyId;
        return _this;
    }
    CorrectionModel.prototype.maxScore = function () {
        return this.essay()
            .subject()
            .examMode().maxScore;
    };
    CorrectionModel.prototype.essay = function () {
        return this.getters.essayReplyById(this.essayReplyId);
    };
    CorrectionModel.prototype.link = function () {
        return this.essay().link();
    };
    CorrectionModel.prototype.correctionScores = function () {
        return this.getters.correctionScoresByCorrectionId(this.id);
    };
    CorrectionModel.prototype.annotations = function () {
        return flatten_1.default(this.correctionScores().map(function (correctionScore) { return correctionScore.annotations(); })).sort(function (a, b) {
            var aCoordinate = a.coordinates;
            var bCoordinate = b.coordinates;
            if (aCoordinate.top < bCoordinate.top) {
                return -1;
            }
            if (aCoordinate.top === bCoordinate.top) {
                return aCoordinate.left - bCoordinate.left;
            }
            return 1;
        });
    };
    return CorrectionModel;
}(Model_1.default));
exports.CorrectionModel = CorrectionModel;
